var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "SweetModal",
        {
          ref: "phoneCallSelect",
          attrs: { title: "Выбор телефона", "overlay-theme": "dark" },
        },
        [
          _c(
            "div",
            [
              _c("h5", [
                _vm._v("\n        Вызов на номер "),
                _c("strong", [_vm._v(_vm._s(_vm.modalData.phoneNum) + " ")]),
              ]),
              _vm._v(" "),
              _c("h6", [_vm._v("Выберите номер с которого совершить вызов")]),
              _vm._v(" "),
              _vm._l(_vm.modalData.phones, function (phone, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "mb-1" },
                  [
                    _c(
                      "vue-ladda",
                      {
                        attrs: {
                          "button-class":
                            "btn btn-success btn-xs phoneCall_btn",
                          "data-style": "zoom-in",
                          loading: _vm.phoneCallLoading,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.makePhoneCall(phone)
                          },
                        },
                      },
                      [_c("i", { staticClass: "icon-fa icon-fa-phone-square" })]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "fs-20" }, [
                      _c("strong", [
                        _vm._v(_vm._s(phone.connected_phone.display_phone)),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "(" + _vm._s(phone.connected_phone.description) + ")"
                        ),
                      ]),
                      _vm._v(" "),
                      phone.recommended
                        ? _c("span", { staticClass: "badge badge-success" }, [
                            _vm._v("Рекомендованный"),
                          ])
                        : _vm._e(),
                    ]),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _vm.hasDefaultSlot
        ? [
            _c(
              "div",
              {
                on: {
                  click: function ($event) {
                    return _vm.selectPhone()
                  },
                },
              },
              [_vm._t("default")],
              2
            ),
          ]
        : [
            _c(
              "vue-ladda",
              {
                attrs: {
                  "button-class": "btn btn-success btn-xs phoneCall_btn",
                  "data-style": "zoom-in",
                  loading: _vm.loading,
                },
                on: {
                  click: function ($event) {
                    return _vm.selectPhone()
                  },
                },
              },
              [_c("i", { staticClass: "icon-fa icon-fa-phone-square" })]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }